/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Repeat from './Repeat';

export const RowsTableSkeleton = ({ count }: any) => {
	return (
		<SkeletonTheme
			borderRadius='6px'
			baseColor='var(--kt-gray-300)'
			highlightColor='var(--kt-light)'
		>
			<Repeat numTimes={count}>
				{(index: any) => (
					<tr key={index} className='system-users-table-row height-72px'>
						<td>
							<Skeleton
								height='20px'
								width='100%'
								style={{ width: '80px' }}
							/>
						</td>
						<td>
							<Skeleton
								height='20px'
								width='100%'
								style={{ width: '80px' }}
							/>
						</td>
						<td
							className='min-width-70 text-align-left'
							style={{ width: '80px' }}
						>
							<Skeleton height='20px' width='100%' />
						</td>
						<td className='text-center' style={{ width: '80px' }}>
							<Skeleton height='24px' width='70px' />
						</td>
						<td className='text-center' style={{ width: '80px' }}>
							<Skeleton height='32px' width='32px' />
						</td>
					</tr>
				)}
			</Repeat>
		</SkeletonTheme>
	);
};

export const HeaderTableSkeleton = () => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<th className="min-w-70px min-width-170">
				<Skeleton height="20px" width="100%" />
			</th>
			<th className="min-w-120px min-width-350">
				<Skeleton height="20px" width="100%" />
			</th>
			<th className="min-w-40px min-width-150 text-align-left">
				<Skeleton height="20px" width="100%" />
			</th>
			<th className="text-center" style={{ width: '100px' }}>
				<Skeleton height="20px" width="100%" />
			</th>
			<th className="text-center" style={{ width: '100px' }}>
				<Skeleton height="20px" width="100%" />
			</th>
		</SkeletonTheme>
	);
};
export const UserProfileLoader = ({ tenant, product }: any) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div className="card system-user-info-card mb-5 mb-xl-8">
				<div className="card-body px-0">
					<div className="d-flex flex-row flex-lg-column text-center px-9 align-items-center">
						<div className="symbol symbol-circle symbol-80px symbol-lg-150px mb-0 mb-lg-5">
							<Skeleton
								height={tenant ? '50px' : '150px'}
								width={tenant ? '50px' : '150px'}
							/>
						</div>
						<div className="text-start text-lg-center ms-3 ms-lg-0 d-flex flex-column align-items-center">
							{!product && (
								<>
									<div className="m-2">
										<Skeleton height="30px" width="100px" />
									</div>
									<div className="d-block mb-3">
										<Skeleton
											height="20px"
											width="100px"
											count={tenant ? 1 : 3}
										/>
									</div>
								</>
							)}
							<Skeleton height="31px" width="74px" />
						</div>
					</div>
				</div>
			</div>
			<div className="card system-user-active-card mb-7">
				<div className="form-check p-5 form-switch form-check-custom form-check-solid d-flex justify-content-between">
					<Skeleton height="20px" width="80px" />
					<Skeleton height="30px" width="50px" />
				</div>
			</div>
		</SkeletonTheme>
	);
};
export const SingleRowLoader = () => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div className="card system-user-active-card mb-7">
				<div className="form-check p-5 form-switch form-check-custom form-check-solid d-flex justify-content-between">
					<Skeleton height="20px" width="80px" />
					<Skeleton height="30px" width="50px" />
				</div>
			</div>
		</SkeletonTheme>
	);
};
export const Loader = ({ height, width, className, ...props }: any) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<Skeleton
				className={className}
				height={height}
				width={width ? width : '100%'}
				{...props}
			/>
		</SkeletonTheme>
	);
};

export const InputWithLabelSkeleton = ({ count }: any) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<Repeat numTimes={count}>
				{(index: any) => (
					<div key={index} className="marginBottom-16px fv-row">
						<Skeleton height="21px" width="30%" />
						<Skeleton height="44px" width="100%" />
					</div>
				)}
			</Repeat>
		</SkeletonTheme>
	);
};

export const MultiInputWithLabelSkeleton = () => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div
				className="one-row h-72 subscription"
				style={{
					marginTop: '17px',
					alignItems: 'center',
					border: 'none'
				}}
			>
				<Repeat numTimes={2}>
					{(index: any) => (
						<div
							key={index}
							className={
								'marginBottom-16px fv-row w-50 ' +
								(index == '1' ? 'ms-5' : '')
							}
						>
							<Skeleton height="21px" width="30%" />
							<Skeleton height="44px" width="100%" />
						</div>
					)}
				</Repeat>
			</div>
		</SkeletonTheme>
	);
};

export const KeyValueLoader = ({ count, title }: any) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			{title && <Skeleton height="30px" width="60%" />}
			<Repeat numTimes={count}>
				{(index: any) => (
					<div key={index}>
						<div
							className="account-information-row "
							style={{
								marginTop: '0px',
								alignItems: 'center',
								height: '50px'
							}}
						>
							<div className="" style={{ border: 'none' }}>
								<Skeleton height="20px" width="80px" />
							</div>
							<div className="form-check form-switch form-check-custom form-check-solid d-flex justify-content-between">
								<Skeleton height="20px" width="50px" />
							</div>
						</div>
					</div>
				)}
			</Repeat>
		</SkeletonTheme>
	);
};

export const DetailWithIcon = () => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div className="w-100 fs-18px mb-5 text-primary">
				<Skeleton
					className="margin-right-16px"
					height="30px"
					width="30px"
				/>
			</div>
			<div className="w-100 fs-18px">
				{/* <label className="text-gray-800 fw-bold line-heigth-21p fs-16px"> */}
				<Skeleton height="21px" width="100%" />
				{/* </label> */}
			</div>
			<div
				className="account-information-row "
				style={{ marginTop: '0px', alignItems: 'center' }}
			>
				<div className="" style={{ border: 'none' }}>
					<Skeleton height="20px" width="80px" />
				</div>
				<div className="form-check form-switch form-check-custom form-check-solid d-flex justify-content-between">
					<Skeleton height="20px" width="50px" />
				</div>
			</div>
		</SkeletonTheme>
	);
};

export const TitleLableSwitchLoader = ({ count }: any) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div className="one-row">
				<Skeleton height="15px" width="150px" count={2} />
			</div>
			<Repeat numTimes={count}>
				{(index: any) => (
					<>
						<div
							className="one-row h-72"
							style={{
								marginTop: '0px',
								alignItems: 'center'
							}}
							key={index}
						>
							<div
								className="role-description"
								style={{ border: 'none' }}
							>
								<Skeleton
									height="18px"
									width="150px"
									count={2}
								/>
							</div>
							<div
								className="form-check form-switch form-check-custom form-check-solid d-flex justify-content-between"
								style={{
									marginInlineStart: '27px',
									height: '30px'
								}}
							>
								<Skeleton height="40px" width="70px" />
							</div>
						</div>
					</>
				)}
			</Repeat>
		</SkeletonTheme>
	);
};
export const TranslateKeyValueLoader = ({ count, title }: any) => {
	return (
		<Repeat numTimes={count}>
			{(index: any) => (
				<SkeletonTheme
					borderRadius="6px"
					baseColor="var(--kt-gray-300)"
					highlightColor="var(--kt-light)"
					key={index}
				>
					{title && <Skeleton height="30px" width="60%" />}
					<>
						<div
							className="account-information-row "
							style={{
								marginTop: '0px',
								alignItems: 'center',
								height: '50px'
							}}
						>
							<div className="" style={{ border: 'none' }}>
								<Skeleton height="20px" width="115px" />
							</div>
							<div className="form-check form-switch form-check-custom form-check-solid d-flex justify-content-between">
								<Skeleton height="20px" width="115px" />
							</div>
						</div>
					</>
				</SkeletonTheme>
			)}
		</Repeat>
	);
};
export const TenantDashboardCardsLoader = ({ count, hideGraph = false}: any) => {
	return (
		<Repeat numTimes={count}>
			{(index: any) => (
				<div key={index} className='col-lg-12 col-xl-4'>
					<div className='card table-card py-4 px-6 mb-4 mb-xl-0'>
						<Loader height='25px' width='60%' />
						{!hideGraph && (
							<div className='my-3'>
								<Loader height='165px' width='100%' />
							</div>
						)}

						<div className='d-flex align-items-end mt-2'>
							<SkeletonTheme
								borderRadius='6px'
								baseColor='var(--kt-gray-300)'
								highlightColor='var(--kt-light)'
								key={index}
							>
								<Skeleton height='50px' width='70px' inline={true} />
								{!hideGraph && (
									<Skeleton
										height='20px'
										width='70px'
										inline={true}
										className='ms-3'
									/>
								)}
							</SkeletonTheme>
						</div>
					</div>
				</div>
			)}
		</Repeat>
	);
};
export const DashboardTitleWithButton = ({ showButton = false }) => {
	return (
		<SkeletonTheme
			borderRadius="6px"
			baseColor="var(--kt-gray-300)"
			highlightColor="var(--kt-light)"
		>
			<div className="d-flex align-items-center">
				<div className="me-auto">
					<Skeleton height="25px" width="120px" />
				</div>
				{showButton && <Skeleton height="33px" width="85px" />}
			</div>
			<Skeleton height="20px" width="80px" />
		</SkeletonTheme>
	);
};
export const RowsTableSkeletonMobile = ({ count }: any) => {
	return (
		<Repeat numTimes={count}>
			{(index: any) => (
				<>
					<tr key={index} className='system-users-table-row height-72px'>
						<td className='min-w-40px' style={{ width: '70px' }}>
							<Skeleton height='20px' width='100%' />
						</td>
						<td className='min-w-70px' style={{ width: '70px' }}>
							<Skeleton height='20px' width='100%' />
						</td>
					</tr>
				</>
			)}
		</Repeat>
	);
};
